module.exports = __webpack_public_path__ + "static/media/consultationMobile.79f54dde.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/consultationMobile.jpg
// module id = 871
// module chunks = 8